import { useState } from 'react';
import cn from 'classnames';

import { IcCheck28, IcCopy20 } from '$assets';

import { CopyButtonProps } from './CopyButton.interface';

import './CopyButton.sass';

export const CopyButton = ({ text, className, position = 'left' }: CopyButtonProps) => {
  const [clipboardSuccess, setClipboardSuccess] = useState(false);

  return (
    <div
      className={cn({
        CopyButton: true,
        [`_${position}`]: true,
        className: !!className,
      })}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setClipboardSuccess(true);
        navigator.clipboard.writeText(text.toString());
        setTimeout(() => setClipboardSuccess(false), 2000);
      }}
    >
      <div className="CopyButton__copy">
        {clipboardSuccess ? <IcCheck28 /> : <IcCopy20 />}
      </div>
      {text}
    </div>
  );
};
